/** Shared DOM-query helpers used across multiple froala handlers. */

export const ICON_SELECTOR =
  'i[data-is-remix-icon="true"], i[data-is-font-awesome-icon="true"]';

export const isIcon = (el: HTMLElement): boolean =>
  el.getAttribute("data-is-remix-icon") === "true" ||
  el.getAttribute("data-is-font-awesome-icon") === "true";

export const findRkpi = (el: HTMLElement): HTMLElement | null =>
  el.closest("[data-rkpi-active]");

export const findHighlight = (el: HTMLElement): HTMLElement | null =>
  el.closest("[data-highlight-active]");
